import { render, staticRenderFns } from "./StackedBarChartWrapper.vue?vue&type=template&id=1d3eaddb&"
import script from "./StackedBarChartWrapper.vue?vue&type=script&lang=js&"
export * from "./StackedBarChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports